import { render, staticRenderFns } from "./article9.vue?vue&type=template&id=62b67e4e&scoped=true"
import script from "./article9.vue?vue&type=script&lang=js"
export * from "./article9.vue?vue&type=script&lang=js"
import style0 from "./article9.vue?vue&type=style&index=0&id=62b67e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b67e4e",
  null
  
)

export default component.exports